export default () => {
	console.error('🚨 Do not use `serverConfig` in the client 🚨'); // eslint-disable-line no-console
	return undefined;
};
